import { Grid, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  content: { marginTop: "1rem" },
  caption: {
    textTransform: "uppercase",
    fontSize: "0.5rem",
    fontWeight: 500,
  },
  value: { color: "white", fontWeight: 500 },
});

interface IProps {
  caption: string;
  value: string;
}

const LabelField = ({ caption, value }: IProps) => {
  const classes = useStyles();

  return (
    <Grid container item direction="column" className={classes.content}>
      <Typography color="textSecondary" className={classes.caption}>
        {caption}
      </Typography>
      <Typography className={classes.value} variant="caption">
        {value}
      </Typography>
    </Grid>
  );
};

export default LabelField;
